import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['labels', 'datasets', 'reload'],
  methods: {
    render () {
      this.renderChart(
        {
          labels: this.labels,
          datasets: this.datasets
        },
        {
          responsive: true,
          maintainAspectRatio: false
        })
    }
  },
  mounted () {
    this.render()
  },
  watch: {
    reload (val) {
      if (val === true) {
        this.render()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Statistic/charts/InsuranceMonthBarChart.js